// test612
(612 && 0);
